import { Group } from 'lib/api/backend.schemas';


export const filterByProperty = formValue => (groups: Group[]) => {
  const extras = formValue?.extras;
  if (!extras || extras.length === 0) {
    return groups;
  }

  const filteredList = groups.filter(group => {
    return extras.every(value => group[value] === true);
  });

  return filteredList;
};
export const filterByAge = formValue => (groups: Group[]) => {
  const minAge = formValue.minAge;
  if (!minAge || minAge.length === 0) {
    return groups;
  }
  const filteredList = groups.filter(group => {
    return (
      group.minAge === null ||
      parseInt(group.minAge?.split(' ')[0]) <= Math.min(...(minAge as number[]))
    );
  });

  return filteredList;
};
export const filterByLicence = formValue => (groups: Group[]) => {
  const license = formValue?.licence;
  if (!license || license.length === 0) {
    return groups;
  }
  const filteredList = groups.filter(group => {
    if (license.includes('B')) {
      return group.licenseClass === 'B';
    }
    if (license.includes('C1')) {
      return group.licenseClass === 'B' || group.licenseClass === 'C1';
    }
    return {};
  });

  return filteredList;
};
export const filterByPrice = ({ formValue, pricesRequestState, currentCategory }) => (groups: Group[]) => {
  if(!pricesRequestState) {
    return groups;
  }
  const prices = formValue?.price;
  if (!prices || prices.length === 0) {
    return groups.filter(group => {
      if(pricesRequestState?.[currentCategory]?.[group?.id]?.hidden) {
        return false;
      }
      return true
    });
  }
  const numericalPrices = {};
  for (const key in pricesRequestState[currentCategory]) {
    if (pricesRequestState[currentCategory][key]?.price) {
      numericalPrices[key] = parseFloat(
        pricesRequestState[currentCategory][key].price.replace(',', '.'),
        );
      }
  }

  const filteredList = groups.filter(group => {
    if(pricesRequestState?.[currentCategory]?.[group?.id]?.hidden) {
      return false;
    }
    const price = numericalPrices[group?.id];
    return !price || price >= prices[0] && price <= prices[1];
  });
  return filteredList;
};
export const filterByCheckBox = formValue => (groups: Group[]) => {
  const checkboxValues = Object.entries(formValue)
    .filter(([key, value]) => value === true && key !== 'paymentEcOnly')
    .map(([key]) => key);
  if (!checkboxValues || checkboxValues.length === 0) {
    return groups;
  }

  const filteredList = groups.filter(group => {
    const hasTrueValue = checkboxValues.some(value => group[value]);

    return hasTrueValue;
  });

  return filteredList;
};
export const filterByEcOnly = formValue => (groups: Group[]) => {
  if (!formValue?.paymentEcOnly) {
    return groups;
  }
  const filteredList = groups.filter(
    group => group.paymentMethods.some(({ type, changeable }) => type === 'EC' && changeable) === true
  );

  return filteredList;
};
export const filterByType = formValue => (groups: Group[]) => {
  const currentTypes = formValue?.type;
  return groups.filter(group => {
    if (currentTypes.length) {
      return currentTypes.includes(group.type);
    }
    return true;
  });
};
export const filterByCategory = currentCategory => (groups: Group[]) => {
  return groups.filter(group => {
    if (currentCategory.length) {
      return currentCategory === group.category;
    }
    return true;
  });
};